export const comments_5698800 = {"data":{"data":[],"links":{}}}